import React, { useEffect } from "react";
import {useDispatch } from "react-redux";
import RouteRegisterer from "./routes/";
import "../styles.scss";
import CommonAction from "stores/common/CommonAction";
import i18n from "../i18n";
import environment from "environment";


const App = () => {
  const dispatch = useDispatch();

  function getInitialLanguage() {
    const env = environment.APP_ENVIRONMENT;
    return env === "alabusTesting" ? "English" : "German";
  }
  
  useEffect(() => {
    const value = getInitialLanguage();
    if (value === 'German') {
      dispatch(CommonAction.setCurrentLanguage("German"));
      i18n.changeLanguage("de");
    } else if (value === 'English') {
      dispatch(CommonAction.setCurrentLanguage("English"));
      i18n.changeLanguage("en");
    }
  }, []);

  // authentication of the user
  if (
    window.location.pathname !== "/login" &&
    !sessionStorage.getItem("authToken")
  ) {
    window.location.href = "/login";
  }
  return (
    <div>
      <RouteRegisterer />
    </div>
  );
};

export default App;
